import React, { useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import clsx from 'clsx';
import { Button, InlineMessages, InlineMessagesType, Types } from '@marriott/mi-ui-library';
import { TextFormField } from '../../../../molecules';
import { RESUBMIT_RFP } from '../../../asp-constants';
import { ResubmitRfpForm } from './ResubmitRfp.types';
import { StyledResubmitRfp, StyledResubmitRfpForm } from './ResubmitRfp.styles';

export const ResubmitRfp = () => {
  const { title, qgIdsLables, submitCta } = RESUBMIT_RFP;
  const {
    control,
    formState: { errors },
    handleSubmit,
    clearErrors,
  } = useForm<ResubmitRfpForm>();
  const [apiError] = useState('');
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');

  const reSubmitRfpCallback = () => {
    setLoading(true);
    // todo to remove
    setTimeout(() => {
      setSuccessMessage(RESUBMIT_RFP.successMessage);
      setLoading(false);
    }, 1000);
  };
  return (
    <StyledResubmitRfp data-testid="groups-ResubmitRfp" data-component-name="m-groups-ResubmitRfp" className="mt-3">
      <div className="container pb-3 px-0">
        {apiError ? (
          <div className="mb-4">
            <InlineMessages type={InlineMessagesType.Error} title={apiError} severity="1" />
          </div>
        ) : null}
        {successMessage ? (
          <div className="mb-4">
            <InlineMessages type={InlineMessagesType.Success} title={successMessage} severity="1" />
          </div>
        ) : null}
        <form onSubmit={handleSubmit(reSubmitRfpCallback)} className="my-7">
          <StyledResubmitRfpForm>
            <div className="t-subtitle-l title">{title}</div>
            <div className="row mt-5">
              <div className="col-12 pb-5">
                <Controller
                  name="qgIds"
                  control={control}
                  rules={{
                    required: qgIdsLables.requiredError,
                  }}
                  render={({ field }) => (
                    <TextFormField
                      {...field}
                      type="text"
                      label={qgIdsLables.label}
                      ariaLabel={qgIdsLables.ariaLabel}
                      className="m-input-field"
                      showErrorMessage={!!errors?.qgIds?.message}
                      errorMessage={errors?.qgIds?.message}
                      testId="qg-ids"
                      onChange={event => {
                        field.onChange(event);
                        clearErrors(field.name);
                      }}
                    />
                  )}
                />
              </div>
            </div>
            <Button
              type={Types.ButtonTypeVariation.Submit}
              className={clsx('m-button-primary m-button-m submit-cta', loading && 'skeleton-loader')}
              ariaLabel={submitCta.ariaLabel}
              isDisabled={loading}
              custom_click_track_value={`${submitCta.location} | ${submitCta.description} | internal`}
            >
              {submitCta.label}
            </Button>
          </StyledResubmitRfpForm>
        </form>
      </div>
    </StyledResubmitRfp>
  );
};
